import { Api } from './api-services';
import qs from 'qs';

export * from './api-services';
export const api = new Api({
  baseURL: '/',
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});
